import { gql } from 'apollo-angular';

export const ARTICLE_CATEGORY_TYPE_POLICY = {
ArticleCategory: {
    keyFields: ['id'],
    fields: {
    // title: { merge: true },
    // synopsis: { merge: true },
    // content: { merge: true },
    // logoInventory: { merge: true },
    // thumbnailInventoryId: { merge: true },
    // thumbnailFileInventory: {
    //     merge(existing: any, incoming: any) {
    //     return incoming ?? existing ?? null;
    //     },
    //     read(existing: any) {
    //     return existing ?? null;
    //     },
    // },
    },
},
};

export const GET_ARTICLE_CATEGORIES_QUERY = gql`
query ArticleCategory($filter: String, $skip: Int, $take: Int) {
    articleCategory(filter: null, skip: null, take: null) {
        hasPreviousPage
        hasNextPage
        totalItems
        items {
            id
            key
            name
            icon
            approved
        }
    }
}
`;